import { finder } from "../../modules/helper";

 export const clientHierarchyFormatter = (value, data) => {
    const accountIds = value.split('_');
    const currentData = accountIds.reduce(finder, {
      ...data,
    });
    return currentData;
  };